import Component from '../core/Component';

export default class Field extends Component {

    constructor($element) {
        super($element);
    }

    prepare() {
        this.$element.on('click', event => {
            event.preventDefault();

            if ($(event.currentTarget).hasClass('is-active')) {

                $(event.currentTarget).removeClass('is-active');
                $(event.currentTarget.hash).slideUp(250).removeClass('is-active');

            } else {

                $('.field').removeClass('is-active');
                $(event.currentTarget).addClass('is-active');

                if ($('.field-content.is-active').length > 0) {
                    $('.field-content.is-active').removeClass('is-active').slideUp(250, () => {
                        $(event.currentTarget.hash).addClass('is-active').slideDown(250, () => {
                            $('html, body').animate({
                                scrollTop: $(event.currentTarget.hash).offset().top - 20
                            });
                            $(event.currentTarget.hash).closest('[data-component-ref="wrap"]').trigger('setWrapHeight');
                        });
                    });
                } else {
                    $(event.currentTarget.hash).addClass('is-active').slideDown(250, () => {
                        $('html, body').animate({
                            scrollTop: $(event.currentTarget.hash).offset().top - 20
                        }, 250);
                        $(event.currentTarget.hash).closest('[data-component-ref="wrap"]').trigger('setWrapHeight');
                    });
                }

            }
        });
    }
}


// WEBPACK FOOTER //
// ./components/Field.js